import { cva } from 'class-variance-authority'

// Kept out of button.tsx ('use client') so server components can call it too
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-base font-normal transition-all duration-300 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive md:cursor-pointer font-medium",
  {
    variants: {
      variant: {
        default: 'bg-primary border border-primary text-primary-foreground hover:bg-primary/90',
        destructive:
          'bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
        outline:
          'border bg-transparent hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50',
        secondary: 'bg-[#F3EEE2] border-secondary text-accent-foreground border hover:opacity-50 ',
        'secondary-outline': 'border-secondary text-accent-foreground border hover:opacity-50 ',
        ghost: 'hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50',
        link: 'text-primary p-0! underline-offset-4 font-medium underline',
        overlay: 'bg-primary/50 backdrop-blur-sm text-primary-foreground',
        grey: 'bg-stone-200 text-stone-900',
        booking: 'bg-green-150 text-foreground hover:opacity-60',
        greenOutline: 'bg-green-100 border border-green-150 hover:bg-green-150',
      },
      size: {
        default: 'h-9 px-4 rounded-full py-2 has-[>svg]:px-3',
        sm: 'h-8 rounded-full gap-1.5 px-3 has-[>svg]:px-2.5',
        lg: 'h-10 px-4 text-md md:text-lg rounded-full md:h-12 md:px-8 has-[>svg]:px-4',
        icon: 'size-10 rounded-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
